/*
*###############################################################################
*Module Name                   : DPSearchBoxDynamicRefTxn.js                           #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*
* NOTE: This component implements debounced search functionality using lodash.debounce
* to improve performance by preventing excessive API calls while typing.
* The search is triggered 1000ms after the user stops typing.
*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, Spinner, Input, InputGroup, InputGroupText, Table, FormGroup, Label } from "reactstrap"
import "../../assets/scss/datatables.scss"
import ReactPaginate from 'react-paginate';
import "../../assets/scss/searchtable.scss"
import { debounce } from 'lodash';

const DPSearchBoxDynamicRefTxn = (props) => {    const [searchPlaceholder, setSearchPlaceholder] = useState(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
    const [searchBy, setSearchBy] = useState("HED_RUNNO") //filter code ex: CM_CODE
    const [page, setPage] = useState(0) //current page
    const [pageSize, setPageSize] = useState(10) //page size
    const [count, setCount] = useState(0) //total row count
    const [data, setData] = useState([]) //data for table
    const [isLoaded, setIsLoaded] = useState(false)
    const [searchString, setSearchString] = useState("") //user entered search string
    const tableRef = useRef(null);
    const [orderBy, setOrderBy] = useState("ASC")//order by ASC or DESC
    const [OrderByString, setOrderByString] = useState(props.columns.length > 0 ? props.columns[0].title : 'code')
    const [selectedRow, setSelectedRow] = useState(0); //highlight selected row , selected row index
    const [selectedColumn, setSelectedColumn] = useState(0); //selected column for search
    const searchref = useRef(null); //search input ref
    const [searchPlace, setSearchPlace] = useState(0)
    const [filteredDataLength, setFilteredDataLength] = useState(0)
    const [loadedData, SetDatatable] = useState([]) //data for table
    const [isDataFetching, setIsDataFetching] = useState(false)
    const [isDebouncing, setIsDebouncing] = useState(false) // New state to track debounced search status

    useEffect(async () => { //when model toggle set default values
        setSearchPlaceholder(`Search By ${props.columns.length > 0 ? props.columns[0].title : 'Code'}`)
        setPage(0)
        setPageSize(10)
        setSelectedColumn(0)
        setCount(0)

        setOrderBy(props.orderBy ? props.orderBy : "DESC")

        if (props.isOpen == true) {
            try {
                setIsLoaded(true)
                setIsDataFetching(true)
                const { searchData, count } = await LoadData(props.fromLocationSelect, props.toLocationSelect, props.intTX_SHOWVAR, props.refTypeSelected, page, pageSize, searchBy, searchString, orderBy, searchPlace, props.txnType)
                setIsDataFetching(false)
                setFilteredDataLength(count)
                SetDatatable(searchData)
                setData(searchData)
            } catch (e) {
                console.log("Error", e)
                setIsLoaded(false)
                setIsDataFetching(false)
            }


        } else {
            setIsLoaded(false)
            setIsDataFetching(false)
            setData([])
            setSelectedRow(0)
        }
        setSearchString("")

    }, [props.isOpen])


    useEffect(async () => {
        if (isLoaded) {
            setOrderBy(props.orderBy ? props.orderBy : "DESC")
        }
    }, [isLoaded])

    useEffect(async () => {

        try {
            setIsDataFetching(true)
            const { searchData, count } = await LoadData(props.fromLocationSelect, props.toLocationSelect, props.intTX_SHOWVAR, props.refTypeSelected, page, pageSize, searchBy, searchString, orderBy, searchPlace, props.txnType)
            setIsDataFetching(false)
            setFilteredDataLength(count)
            SetDatatable(searchData)
            setData(searchData)
        } catch (e) {
            console.log("Error", e)
            setIsLoaded(false)
            setIsDataFetching(false)
        }



    }, [page, pageSize, searchString, orderBy, searchBy, searchPlace])



    const handlePageClick = (event) => {
        setPage(event.selected);
    };

    if (searchref.current) {
        searchref.current.focus()
    }    const handleKeyPress = (event) => { // key press event handling function 
        if (event.key === 'ArrowUp') { // if key is arrow up select previous row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.max(selectedRow - 1, 0));
        } else if (event.key === 'ArrowDown') { // if key is arrow down select next row
            event.preventDefault();
            setSelectedRow((selectedRow) => Math.min(selectedRow + 1, loadedData.length - 1));
        } else if (event.key === 'Enter') { // if key is enter call select function
            if (loadedData.length === 0) return;
            props.getSelect(event, loadedData[selectedRow]);
        } else if (event.key === 'ArrowRight') { // if key is arrow right select next page
            // Check if we can go to the next page
            const maxPage = Math.ceil(filteredDataLength / pageSize) - 1;
            if (page < maxPage) {
                setPage(page + 1);
                setSelectedRow(0); // set selected row to 0 when page changes
            }
        } else if (event.key === 'ArrowLeft') { // if key is arrow left select previous page
            // Check if we can go to the previous page
            if (page > 0) {
                setPage(page - 1);
                setSelectedRow(0); // set selected row to 0 when page changes
            }
        }

        if (event.ctrlKey && event.key == 'x') {
            // add your code to handle the Control + X key event here
            setSearchPlace(searchPlace == 0 ? 1 : 0)
        }




    };
    const handleOptionChange = (event) => {
        setSearchPlace(event.target.value);
    };    const debouncedSearch = useCallback(
        debounce((value) => {
            setSearchString(value);
            setPage(0);
            setIsDebouncing(false); // Search is complete, turn off debouncing indicator
        }, 1000),
        []
    );

    const handleSearch = useCallback((e) => {
        const userInput = e.target.value;
        const sanitizedInput = userInput.replace(/[^a-zA-Z0-9]/g, '');
        setIsDebouncing(true); // Show that search is in debounce mode
        debouncedSearch(sanitizedInput);
    }, [debouncedSearch]);

    return (
        <div onKeyDown={handleKeyPress}>
            <Modal
                id="dynamicSearchModal"
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
                centered
                className="search-modal"
            >
                <div className="modal-header">
                    <h5 className="modal-title">{props.mainTitle}</h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body p-4">
                    <Card>
                        <CardBody>
                            {props.SubTitle && (
                                <CardTitle tag="h5" className="mb-4">{props.SubTitle}</CardTitle>
                            )}
                            <p className="card-title-desc">
                                {"Please click on the column header to change searching criteria. Press Ctrl + X to change search by first letter or middle letter."}
                            </p>
                                    <>                                        <div className="search-controls mb-4">
                                            <Row className="align-items-center">
                                                <Col md={7}>
                                                    <div className="d-flex">
                                                        <FormGroup check inline>
                                                            <Input
                                                                type="radio"
                                                                id="searchMiddle"
                                                                name="searchType"
                                                                value="0"
                                                                checked={searchPlace == 0}
                                                                onChange={handleOptionChange}
                                                            />
                                                            <Label check for="searchMiddle">
                                                                Search by Middle Letter
                                                            </Label>
                                                        </FormGroup>
                                                        <FormGroup check inline>
                                                            <Input
                                                                type="radio"
                                                                id="searchFirst"
                                                                name="searchType"
                                                                value="1"
                                                                checked={searchPlace == 1}
                                                                onChange={handleOptionChange}
                                                            />
                                                            <Label check for="searchFirst">
                                                                Search by First Letter
                                                            </Label>
                                                        </FormGroup>
                                                    </div>
                                                </Col>
                                                <Col md={5}>                                                    <InputGroup size="sm">
                                                        <InputGroupText>
                                                            {isDebouncing ? (
                                                                <i className="fas fa-spinner fa-spin text-primary" title="Search in progress..."></i>
                                                            ) : (
                                                                <i className="fas fa-search"></i>
                                                            )}
                                                        </InputGroupText>
                                                        <Input
                                                            innerRef={searchref}
                                                            id="SearchBarDynamic"
                                                            type="text"
                                                            placeholder={isDebouncing ? "Search in progress..." : searchPlaceholder}
                                                            onChange={handleSearch}
                                                        />
                                                    </InputGroup>
                                                    <div className="mt-1">
                                                        <small className="text-muted">
                                                            <i className="fas fa-info-circle me-1"></i>
                                                            Search starts automatically after you stop typing
                                                        </small>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </>                                    <div className="table-responsive">
                                        <Table bordered size="sm" className="mb-0 table-hover" style={{ backgroundColor: "#ffffff" }} innerRef={tableRef} id="searchTable">
                                            <thead style={{ backgroundColor: "#ffffff" }}>
                                                <tr>
                                                    {props.columns.map((column, index) => {
                                                        return (
                                                            <th key={index} style={{ textAlign: column.align, cursor: "pointer" }} onClick={e => {
                                                                setPage(0)
                                                                setSearchBy(column.dataField)
                                                                setSearchPlaceholder(`Search By ${column.title}`)
                                                                setOrderByString(column.title)
                                                                setSearchString("")

                                                                const element = document.getElementById("SearchBarDynamic");

                                                                if (element) {
                                                                    element.focus();
                                                                }

                                                                setSelectedColumn(pre => {
                                                                    if (pre == index) {
                                                                        orderBy == "ASC" ? setOrderBy("DESC") : setOrderBy("ASC")
                                                                    } else {
                                                                        setOrderBy("ASC")
                                                                    }
                                                                    return index
                                                                })
                                                            }}>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <span>{column.title}</span>
                                                                    {selectedColumn === index && (
                                                                        <i className={`fas fa-sort-${orderBy.toLowerCase()}`}></i>
                                                                    )}
                                                                </div>
                                                            </th>
                                                        )
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody style={{ backgroundColor: "#ffffff" }}>
                                                {isDataFetching ?
                                                    <tr>
                                                        <td colSpan={props.columns.length} className="text-center">
                                                            <Spinner className="ms-2" color="primary" size="sm" />
                                                            Loading...
                                                        </td>
                                                    </tr> :
                                                    loadedData.length > 0 ? (
                                                        loadedData.map((row, index) => {
                                                            return (
                                                                <tr
                                                                    key={index}
                                                                    className={index === selectedRow ? 'fw-bold' : ''}
                                                                    style={{ cursor: 'pointer', backgroundColor: "#ffffff" }}
                                                                    onClick={e => {
                                                                        props.getSelect(e, row)
                                                                    }}>
                                                                    {props.columns.map((column, colIndex) => {
                                                                        return (
                                                                            <td key={colIndex} style={{ textAlign: column.align, backgroundColor: "#ffffff" }}>{row[column.title]}</td>
                                                                        )
                                                                    })}
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={props.columns.length} className="text-center">
                                                                <div className="text-muted">
                                                                    <i className="fas fa-search me-2"></i>
                                                                    No data found
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                            </tbody>
                                        </Table>
                                    </div>                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        <div className="d-flex align-items-center">
                                            <span className="me-2">Page Size:</span>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                style={{ width: "80px" }}
                                                value={pageSize}
                                                onChange={e => setPageSize(Number(e.target.value))}
                                            >
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </Input>
                                            <span className="ms-4">
                                                Total Records: {Math.ceil(filteredDataLength)}
                                            </span>
                                        </div>

                                        <ReactPaginate
                                            previousLabel={<i className="fas fa-chevron-left" />}
                                            nextLabel={<i className="fas fa-chevron-right" />}
                                            breakLabel="..."
                                            pageCount={Math.ceil(filteredDataLength / pageSize)}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            forcePage={page}
                                            containerClassName="pagination pagination-sm mb-0"
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            activeClassName="active"
                                        />
                                    </div>                                </CardBody>
                        </Card>
                    </div>
                </Modal>
            </div>
        );
}

export default DPSearchBoxDynamicRefTxn;



const LoadData = async (fromLocationSelect, toLocationSelect, intTX_SHOWVAR, refTypeSelected, page, pageSize, searchBy, searchString, orderBy, searchPlace, txnType) => {

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    var offset = page * pageSize

    var searchData = [];
    let dt = [];
    let rowcount = 0
    //const ApiURL = window.Links.ApiURL

    if (refTypeSelected == "") {
        return { "searchData": searchData, "count": rowcount }
    }


    await fetch(`${ApiURL}txn/select/refTxn`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
            "fromLocation": fromLocationSelect,
            "toLocation": toLocationSelect,
            "strType": refTypeSelected,
            "pageNo": String(offset),
            "Count": String(pageSize),
            "filterColumn": searchBy,
            "filterValue": searchString,
            "orderBy": orderBy,
            "searchPlace": String(searchPlace),
            "txnType": txnType
        })
    }).then(Response => Response.json())
        .then(responseData => {
            dt = responseData.data
            rowcount = responseData.count
            if (dt.length > 0) {
                dt.map((row, index) => {
                    searchData.push(TableDataBuilder(index, row))
                });
            }
        }).catch(error => {
            console.log("Error", error)
        })

    return { "searchData": searchData, "count": rowcount }

}


const TableDataBuilder = (id, Data) => {
    return {
        "id": id,
        "Document No": Data.strHED_RUNNO,
        "Date": Data.dtHED_TXNDATE.substring(0, 10),
        "Supplier": Data.strHED_SUPCODE,
        "Name": Data.strHED_SUPNAME,
        "Processed": Data.strHED_PROCESSED,
        "Amount": Data.decHED_NETAMOUNT,
        "From Loc": Data.strHED_LOCFROM,
        "To Loc": Data.strHED_LOCTO,
        "Remarks1": Data.strHED_REF1,
        "Remarks2": Data.strHED_REF2
    }
}